import NursingPlacement from "./NursingPlacementPage";

export default NursingPlacement;
